import { useState, useEffect } from 'react'

interface OptimisticProgramData {
	programId: string | null
	isOptimistic: boolean
}

export function useOptimisticProgram(): OptimisticProgramData {
    const [programId, setProgramId] = useState<string | null>(() => {
        try {
            return localStorage.getItem('selectedProgramId')
        } catch {
            return null
        }
    })

    useEffect(() => {
        const handleStorageChange = () => {
            try {
                setProgramId(localStorage.getItem('selectedProgramId'))
            } catch {
                setProgramId(null)
            }
        }

        window.addEventListener('storage', handleStorageChange)
        
        // Remove or dramatically reduce polling frequency
        // const interval = setInterval(handleStorageChange, 5000) // 5 seconds if needed

        return () => {
            window.removeEventListener('storage', handleStorageChange)
            // clearInterval(interval)
        }
    }, []) // Remove programId dependency to prevent unnecessary re-runs

    return { programId, isOptimistic: true }
}

